import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import "react-icons/ai";
import { AiOutlineWarning } from "react-icons/ai";
import { extendSession, logout } from "../actions/adminActions";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDispatch } from "react-redux";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
const Modal = ({ time, setSession, countDownTimer, timer }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessionMinutes = 60;
  if (!time) return null;

  const logoutSession = async () => {
    setLoading(true);
    clearInterval(countDownTimer);
    await dispatch(logout(navigate));

    setLoading(false);
    setSession({ time: false });
  };
  const extendTime = async () => {
    setLoading(true);
    clearInterval(countDownTimer);
    const sessionTime = {
      session:
        new Date(
          new Date().toLocaleString("en-US", { timeZone: "Asia/Manila" })
        ).getTime() +
        sessionMinutes * 60000,
    };
    await extendSession(sessionTime);

    setLoading(false);
    alertify.set("notifier", "position", "top-center");
    alertify.success("Successfully extended session");
    timer(sessionTime.session);
    setSession({ time: false });
  };
  return ReactDOM.createPortal(
    <div className="modal-container">
      <div className="modal-session">
        <div className="warning">
          <AiOutlineWarning className="warning-logo" />
          <div className="warning-text">
            <h6 className="expire-title">Your session is about to expire!</h6>
            <p className="expire-content">
              You will be logged out in <b>{time}</b> seconds. Do you want to
              stay signed in?
            </p>
          </div>
        </div>

        <div className="row">
          <button onClick={() => extendTime()}>
            {" "}
            {loading ? (
              <div>
                <FontAwesomeIcon icon={faCog} className="fa-spin" />
                {"Yes, keep me signed in"}
              </div>
            ) : (
              "Yes, keep me signed in"
            )}
          </button>
          <button onClick={() => logoutSession()}>No, Sign me out</button>
        </div>
      </div>
    </div>,
    document.getElementById("modal")
  );
};

export default Modal;
